import { getCookie, setCookie, removeCookie } from 'react-simple-cookie-store'

export const getCookieValue = (key: string) => {
  return getCookie(key)
}

export const setCookieValue = (key: string, value: string, days?: number) => {
  return setCookie(key, value, days || 30) // Default to 30 days
}

export const removeCookieValue = (key: string) => {
  return removeCookie(key)
}

export const getUserDismissalKey = (userId: string, bannerType: string) => {
  return `dismissed_banner_${bannerType}_${userId}`
}